import { HOUSE_LADDER, TierListEditor, type TierDraft } from './product-price-tiers';

export { HOUSE_LADDER };

/**
 * Stages catalogue cost ladders while a product is being created.
 *
 * Prices cannot be part of `createProduct` — they are their own rows, keyed to a
 * product that does not exist yet — so this collects them and the modal writes
 * them once the new id comes back, the same way staged images are attached.
 *
 * Each tier names its own supplier, because that is where the backend keeps it:
 * `vetterEntityId` is a column on the price row, and a supplier with a row at
 * 500 but none at 1000 is quoted its own price at 500 and the house price at
 * 1000. There is deliberately no ladder-level picker above the list — it said
 * the same thing as the control on the tier directly beneath it.
 */
export function ProductPricesStep({
	tiers,
	onTiersChange,
	currency,
}: {
	tiers: TierDraft[];
	onTiersChange: (next: TierDraft[]) => void;
	currency: string;
}) {
	return (
		<div className="flex flex-col gap-3">
			<p className="text-2xs text-text-4">
				A price with no supplier is the fallback, used for any supplier without one of its
				own. Costs only — this is never shown to a client.
			</p>

			<TierListEditor
				tiers={tiers}
				onChange={onTiersChange}
				currency={currency}
				supplierPicker
				emptyNote="No prices. You can add them later from the product’s Prices tab."
			/>
		</div>
	);
}
